import { ApiOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import { NavItemType } from '../types/menu';
import { DeepReadonly } from '../types/DeepReadonly';
import { useMemo } from 'react';

export const useConnectionMenuItems = (): DeepReadonly<NavItemType>[] =>
	useMemo(
		() => [
			{
				id: 'metrics',
				title: <FormattedMessage id={'menu.metrics'} />,
				type: 'item',
				url: '/connections/metrics',
				icon: ApiOutlined,
			},
			{
				id: 'activities',
				title: <FormattedMessage id={'menu.activities'} />,
				type: 'item',
				url: '/connections/activities',
				icon: ApiOutlined,
			},
			{
				id: 'data-sources',
				title: <FormattedMessage id={'menu.data-sources'} />,
				type: 'item',
				url: '/connections/data-sources',
				icon: ApiOutlined,
			},
		],
		[],
	);
